var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExImLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.2341L20.8914 19.8896L40 5.2341L24.96 0L0 5.2341Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.22742L6.21714 26.1638L17.8743 34.5384L20.8914 19.8829L0 5.22742Z",
    fill: "url(#paint0_linear_5071_682)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9704 16.7491L24.9475 0L39.9875 5.2341V16.7491H36.9704Z",
    fill: "#3BCD3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21338 26.1835L36.9791 16.7621H39.9962L17.8705 34.558L6.21338 26.1835Z",
    fill: "#02104F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5071_682",
    x1: 5.21413,
    y1: 6.23054,
    x2: 16.4703,
    y2: 29.1746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3024,
    stopColor: "#007465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#349E79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExImLogo);
export default __webpack_public_path__ + "static/media/ExImLogo.efbbac51465591ef0f002b1f05047ed9.svg";
export { ForwardRef as ReactComponent };